export const botLogos = Array.from(
  { length: 38 },
  (_, index) => `https://storage.googleapis.com/qp-bot-logos/${index + 1}.png`
);
